var _circle, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMypage(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_54_10242)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_54_10242",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 1,
    width: 30,
    height: 30
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16.0002,
    cy: 16.0007,
    r: 14.6667,
    fill: "#DFE0E2"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_54_10242)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 16.0002,
    cy: 16.0007,
    r: 14.6667,
    fill: "#E0E3E1"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16.0002,
    cy: 16.0007,
    r: 13.8519,
    stroke: "#171E26",
    strokeOpacity: 0.2,
    strokeWidth: 1.62963
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.22217 31.4533V29.9859C6.22217 24.511 9.721 20.0732 14.037 20.0732H17.9629C22.2789 20.0732 25.7777 24.511 25.7777 29.9859V31.4533H6.22217Z",
    fill: "#A9ACAA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.2052 6.22168H14.795C12.3105 6.22168 10.2964 8.30469 10.2964 10.8742C10.2964 13.4437 12.3105 15.5268 14.795 15.5268H17.2052C19.6897 15.5268 21.7038 13.4437 21.7038 10.8742C21.7038 8.30469 19.6897 6.22168 17.2052 6.22168Z",
    fill: "#A9ACAA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0004 16.0007C21.4005 16.0007 25.7782 14.5413 25.7782 12.7411C25.7782 10.9408 21.4005 9.48145 16.0004 9.48145C10.6003 9.48145 6.22266 10.9408 6.22266 12.7411C6.22266 14.5413 10.6003 16.0007 16.0004 16.0007Z",
    fill: "#A9ACAA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.0675 12.1611H13.9322C11.619 12.1611 11.1652 13.073 11.1519 13.226C11.1386 13.3791 11.1113 14.2646 11.1113 14.4834V15.7644C11.1113 18.5776 13.2996 20.3093 16.0002 20.3093C18.7002 20.3093 20.8891 18.5783 20.8891 15.7644V14.4834C20.8891 14.2681 20.8778 13.4656 20.8486 13.2267C20.8193 12.9879 20.0146 12.1611 18.0675 12.1611Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14.3706,
    y: 17.6299,
    width: 3.25926,
    height: 4.88889,
    rx: 1.62963,
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_54_10242"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMypage);
export default __webpack_public_path__ + "static/media/mypage.5ba6193c04fbd45d4d2df798f4134727.svg";
export { ForwardRef as ReactComponent };